function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.9983 9.9257C43.3913 7.56086 42.7708 5.78896 42.1123 4.34454L40.8989 4.89956C41.5686 6.21603 41.8643 7.69098 41.7538 9.16385H39.5613C39.1408 9.16385 38.6271 9.06388 38.0342 8.32961L37 9.16385C37.7343 10.067 38.5513 10.4911 39.5682 10.4911H42.9121L42.9983 9.9257Z",
  fill: "#4A5153"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M46.3389 4.92369C46.3389 4.94782 47.4937 7.22647 46.6836 9.23624C46.1975 10.4256 45.0944 11.3046 43.4121 11.8803L43.8396 13.1386C45.9079 12.4491 47.2869 11.2943 47.9246 9.72575C48.9588 7.15063 47.5868 4.43417 47.5144 4.33765L46.3389 4.92369Z",
  fill: "#4A5153"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M51.0614 7.46438C51.0614 7.1281 51.1612 6.79938 51.3481 6.51983C51.535 6.24027 51.8006 6.02244 52.1113 5.89391C52.4221 5.76538 52.764 5.73193 53.0937 5.79778C53.4235 5.86364 53.7263 6.02584 53.9639 6.26387C54.2014 6.50189 54.363 6.80504 54.4282 7.13494C54.4934 7.46484 54.4592 7.80666 54.3301 8.11715C54.2009 8.42763 53.9825 8.69282 53.7026 8.87915C53.4227 9.06548 53.0937 9.16457 52.7575 9.16389C52.3088 9.1639 51.8785 8.98615 51.5606 8.66957C51.2427 8.35298 51.0632 7.92335 51.0614 7.47472V7.46438ZM52.7575 4.45835C51.9939 4.48679 51.2695 4.80399 50.7308 5.34585C50.192 5.88771 49.879 6.61386 49.8549 7.37761C49.8308 8.14135 50.0975 8.88577 50.6011 9.46049C51.1047 10.0352 51.8076 10.3974 52.5679 10.4739C51.6456 11.0829 50.64 11.5555 49.5825 11.8769L50.0031 13.1386C55.698 11.2736 55.8152 8.17797 55.7876 7.60227C55.7876 7.55401 55.7876 7.5092 55.7876 7.46438C55.7849 6.66224 55.4639 5.894 54.895 5.32841C54.3262 4.76283 53.5562 4.44617 52.754 4.44801",
  fill: "#4A5153"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M89.2503 2.61412C89.3918 2.61478 89.5304 2.57356 89.6485 2.49563C89.7666 2.41771 89.859 2.30656 89.9141 2.17621C89.9692 2.04585 89.9845 1.90211 89.9581 1.76308C89.9316 1.62406 89.8646 1.49597 89.7655 1.39494C89.6664 1.29392 89.5396 1.22449 89.4011 1.19538C89.2626 1.16628 89.1186 1.17881 88.9872 1.23139C88.8558 1.28397 88.743 1.37426 88.6628 1.49088C88.5826 1.6075 88.5387 1.74524 88.5367 1.88674C88.5353 1.98148 88.5527 2.07555 88.588 2.16352C88.6232 2.25148 88.6755 2.3316 88.7418 2.39924C88.8082 2.46687 88.8873 2.52069 88.9745 2.55757C89.0618 2.59445 89.1555 2.61367 89.2503 2.61412",
  fill: "#4A5153"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M89.2503 7.03008C88.9908 7.02872 88.7376 6.95053 88.5225 6.80539C88.3074 6.66024 88.1402 6.45464 88.0418 6.21453C87.9435 5.97442 87.9184 5.71055 87.9699 5.45623C88.0213 5.20191 88.147 4.96853 88.3309 4.78553C88.5149 4.60254 88.7489 4.47813 89.0035 4.42801C89.2581 4.37788 89.5218 4.40429 89.7614 4.5039C90.001 4.60351 90.2057 4.77186 90.3497 4.98769C90.4938 5.20353 90.5706 5.45719 90.5706 5.71667C90.5688 6.06564 90.4289 6.3997 90.1815 6.64581C89.9341 6.89193 89.5993 7.03009 89.2503 7.03008ZM91.8772 5.71667C91.8816 5.13791 91.6953 4.5738 91.347 4.11154C90.9988 3.64928 90.5079 3.31462 89.9504 3.15928C89.3928 3.00394 88.7997 3.03658 88.2625 3.25216C87.7254 3.46773 87.2742 3.85423 86.9788 4.35191C86.6833 4.8496 86.56 5.43074 86.628 6.00551C86.6959 6.58029 86.9513 7.11667 87.3546 7.53176C87.758 7.94685 88.2868 8.21753 88.8594 8.30194C89.432 8.38635 90.0164 8.27981 90.5224 7.99877C90.4363 8.33833 90.2393 8.63942 89.9627 8.85426C89.686 9.0691 89.3455 9.18538 88.9952 9.18464H63.737C64.0461 8.72005 64.2105 8.17417 64.2092 7.61612V1.13867H62.9027V7.61612C62.9023 7.82255 62.8612 8.02688 62.7817 8.21742C62.7023 8.40797 62.5861 8.58101 62.4399 8.72666C62.2936 8.87231 62.12 8.98772 61.9291 9.0663C61.7382 9.14488 61.5337 9.18509 61.3273 9.18464H60.1759C60.3438 8.24874 60.2833 7.28614 59.9994 6.37866C59.7155 5.47119 59.2167 4.64569 58.5453 3.97234L57.618 4.88932C58.1696 5.44269 58.5713 6.12729 58.7854 6.87871C58.9995 7.63012 59.0189 8.42365 58.8418 9.18464H56.7734V10.4843H89.2262C89.9466 10.428 90.6195 10.1029 91.1112 9.57347C91.603 9.04404 91.8776 8.34903 91.8806 7.62646V5.81319C91.8806 5.77872 91.8806 5.74769 91.8806 5.71667",
  fill: "#4A5153"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M6.45298 0L8.4601 3.87121L12.906 4.51296L9.69027 7.5147L10.4456 11.7792L6.45298 9.77118L2.46034 11.7792L3.2157 7.5147L0 4.51296L4.46745 3.87121L6.45298 0Z",
  fill: "#4A5153"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.49707 6.41751L8.48261 3.87121L6.49707 0V6.41751Z",
  fill: "url(#paint0_linear_1075_13006)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M6.40985 0L4.42432 3.87121L6.40985 6.41751V0Z",
  fill: "url(#paint1_linear_1075_13006)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M6.38914 6.438L4.48992 3.82959L0.0224609 4.45064L6.38914 6.438Z",
  fill: "url(#paint2_linear_1075_13006)"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4.53418L3.2157 7.53592L6.36667 6.52154L0 4.53418Z",
  fill: "url(#paint3_linear_1075_13006)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M6.38896 6.54218L3.21641 7.47375L2.43945 11.7383L6.38896 6.54218Z",
  fill: "url(#paint4_linear_1075_13006)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M2.50342 11.7796L6.49606 9.77155L6.45289 6.5835L2.50342 11.7796Z",
  fill: "url(#paint5_linear_1075_13006)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M6.4754 6.5835L6.41064 9.77155L10.4033 11.7796L6.4754 6.5835Z",
  fill: "url(#paint6_linear_1075_13006)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4679 11.7383L9.71258 7.47375L6.54004 6.54218L10.4679 11.7383Z",
  fill: "url(#paint7_linear_1075_13006)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M6.54004 6.50084L9.69099 7.53592L12.9067 4.53418L6.54004 6.50084Z",
  fill: "url(#paint8_linear_1075_13006)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M12.8852 4.45064L8.43934 3.82959L6.51855 6.438L12.8852 4.45064Z",
  fill: "url(#paint9_linear_1075_13006)"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M19.7732 11.0853L17 3.13898H18.7664L20.7977 9.25543L22.8113 3.13898H24.5776L21.7869 11.0853H19.7732Z",
  fill: "#4A5153"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M25.4092 3.13898H27.0342V11.0853H25.4092V3.13898Z",
  fill: "#4A5153"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M31.6779 3.13934C32.0496 3.13138 32.4192 3.19472 32.765 3.32565C33.1108 3.45658 33.4258 3.65245 33.6916 3.90178C34.2106 4.41138 34.5011 5.0955 34.5011 5.80788C34.5011 6.52025 34.2106 7.20437 33.6916 7.71397C33.4258 7.9633 33.1108 8.15917 32.765 8.2901C32.4192 8.42103 32.0496 8.48438 31.6779 8.47641H30.2118V11.0856H28.6045V3.13934H31.6779ZM31.6779 7.01931C31.8402 7.02205 32.0013 6.99176 32.1505 6.93043C32.2997 6.8691 32.4336 6.77812 32.5434 6.6635C32.6567 6.54826 32.7448 6.41243 32.8024 6.26402C32.86 6.11561 32.8861 5.95763 32.8791 5.7994C32.8894 5.48035 32.7689 5.17013 32.5434 4.93531C32.4301 4.8262 32.2951 4.74 32.1465 4.68179C31.9978 4.62359 31.8385 4.59457 31.6779 4.59645H30.2118V7.01931H31.6779Z",
  fill: "#4A5153"
});

var _ref21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1075_13006",
  x1: 6.49707,
  y1: 3.20876,
  x2: 8.48261,
  y2: 3.20876,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDFFF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#FCF7DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#F8E3A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3C34E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1B932"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1075_13006",
  x1: 5.41708,
  y1: 6.43822,
  x2: 5.41708,
  y2: 0,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#5F3618"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#DCA24E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#E5C466"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#EBDC77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#EDE57D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1075_13006",
  x1: 3.21659,
  y1: 5.46502,
  x2: 3.77671,
  y2: 3.62979,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDE579"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#EBD672"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#E6B964"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#E2B561"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#D8A959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#C6954B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#AD7937"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A57031"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1075_13006",
  x1: 3.84158,
  y1: 7.3496,
  x2: 2.62003,
  y2: 3.6335,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#B9873C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1075_13006",
  x1: 4.98613,
  y1: 9.81304,
  x2: 3.2031,
  y2: 7.48413,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_1075_13006",
  x1: 7.01402,
  y1: 8.48805,
  x2: 1.97518,
  y2: 9.98573,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_1075_13006",
  x1: 193.227,
  y1: 41.3455,
  x2: 189.421,
  y2: 47.2408,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_1075_13006",
  x1: 8.05077,
  y1: 6.31446,
  x2: 9.26431,
  y2: 14.5275,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#AA7534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#DCA24E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_1075_13006",
  x1: 9.62625,
  y1: 5.30014,
  x2: 10.3894,
  y2: 7.26818,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_1075_13006",
  x1: 12.1298,
  y1: 6.35519,
  x2: 7.32816,
  y2: 4.41959,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEAC1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#EFB534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#F3CD6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F9F3C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBFFE1"
})));

function SvgVipPointsAr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 14,
    viewBox: "0 0 92 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipPointsAr);
export default __webpack_public_path__ + "static/media/vip-points-ar.e6eddf6f.svg";
export { ForwardRef as ReactComponent };